import Head from 'next/head';

import { ExternalFonts } from '@/components/common/ExternalFonts';

export const CustomStyles = () => {
  return (
    <>
      <ExternalFonts
        href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;1,400;1,500&family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap"
        preconnect={['https://fonts.googleapis.com', 'https://fonts.gstatic.com']}
      />

      <Head>
        <style>{`
          :root {
            /* Bonfire alias */
            --bf-desktop-body-interactive-button-font-family: 'Poppins';
            --bf-desktop-body-interactive-link-font-family: 'Poppins';
            --bf-desktop-body-label-label-font-family: 'Poppins';
            --bf-desktop-body-large-bold-font-family: 'Poppins';
            --bf-desktop-body-large-link-font-family: 'Poppins';
            --bf-desktop-body-large-regular-font-family: 'Poppins';
            --bf-desktop-body-legal-bold-font-family: 'Poppins';
            --bf-desktop-body-legal-link-font-family: 'Poppins';
            --bf-desktop-body-legal-regular-font-family: 'Poppins';
            --bf-desktop-body-medium-bold-font-family: 'Poppins';
            --bf-desktop-body-medium-link-font-family: 'Poppins';
            --bf-desktop-body-medium-regular-font-family: 'Poppins';
            --bf-desktop-body-small-bold-font-family: 'Poppins';
            --bf-desktop-body-small-link-font-family: 'Poppins';
            --bf-desktop-body-small-regular-font-family: 'Poppins';
            --bf-desktop-header-display-regular-font-family: 'Poppins';
            --bf-desktop-header-h1-regular-font-family: 'Poppins';
            --bf-desktop-header-h2-regular-font-family: 'Poppins';
            --bf-desktop-header-h3-regular-font-family: 'Poppins';
            --bf-desktop-header-h4-regular-font-family: 'Poppins';
            --bf-desktop-header-h5-regular-font-family: 'Poppins';
            --bf-desktop-header-h6-regular-font-family: 'Poppins';
            --bf-font-family-sans-serif: 'Poppins';
            --bf-mobile-body-label-font-family: 'Poppins';
            --bf-mobile-body-large-bold-font-family: 'Poppins';
            --bf-mobile-body-large-link-font-family: 'Poppins';
            --bf-mobile-body-large-regular-font-family: 'Poppins';
            --bf-mobile-body-legal-bold-font-family: 'Poppins';
            --bf-mobile-body-legal-link-font-family: 'Poppins';
            --bf-mobile-body-legal-regular-font-family: 'Poppins';
            --bf-mobile-body-medium-bold-font-family: 'Poppins';
            --bf-mobile-body-medium-link-font-family: 'Poppins';
            --bf-mobile-body-medium-regular-font-family: 'Poppins';
            --bf-mobile-body-small-bold-font-family: 'Poppins';
            --bf-mobile-body-small-link-font-family: 'Poppins';
            --bf-mobile-body-small-regular-font-family: 'Poppins';
            --bf-mobile-header-display-regular-font-family: 'Poppins';
            --bf-mobile-header-h1-regular-font-family: 'Poppins';
            --bf-mobile-header-h2-regular-font-family: 'Poppins';
            --bf-mobile-header-h3-regular-font-family: 'Poppins';
            --bf-mobile-header-h4-regular-font-family: 'Poppins';
            --bf-mobile-header-h5-regular-font-family: 'Poppins';
            --bf-mobile-header-h6-regular-font-family: 'Poppins';
            --bf-mobile-interactive-button-font-family: 'Poppins';
            --bf-mobile-interactive-link-font-family: 'Poppins';
            /* Bonfire component */
            --bf-accordion-description-text-typography-desktop-font-family: 'Poppins';
            --bf-accordion-description-text-typography-mobile-font-family: 'Poppins';
            --bf-accordion-label-text-typography-desktop-font-family: 'Poppins';
            --bf-accordion-label-text-typography-mobile-font-family: 'Poppins';
            --bf-activitybar-item-text-typography-normal-font-family: 'Poppins';
            --bf-activitybar-item-text-typography-selected-font-family: 'Poppins';
            --bf-alert-body-text-typography-font-family: 'Poppins';
            --bf-alert-header-text-typography-font-family: 'Poppins';
            --bf-avatar-text-typography-large-font-family: 'Poppins';
            --bf-avatar-text-typography-medium-font-family: 'Poppins';
            --bf-avatar-text-typography-small-font-family: 'Poppins';
            --bf-button-text-typography-font-family: 'Poppins';
            --bf-card-description-text-typography-font-family: 'Poppins';
            --bf-card-header-text-typography-font-family: 'Poppins';
            --bf-checkbox-description-text-typography-font-family: 'Poppins';
            --bf-checkbox-label-text-typography-normal-font-family: 'Poppins';
            --bf-chip-text-typography-large-font-family: 'Poppins';
            --bf-chip-text-typography-small-font-family: 'Poppins';
            --bf-controller-text-typography-default-font-family: 'Poppins';
            --bf-controller-text-typography-marketing-font-family: 'Poppins';
            --bf-dropdown-input-text-typography-font-family: 'Poppins';
            --bf-dropdown-label-large-text-typography-font-family: 'Poppins';
            --bf-dropdown-label-small-text-typography-font-family: 'Poppins';
            --bf-dropdown-tile-category-text-typography-font-family: 'Poppins';
            --bf-dropdown-tile-description-text-typography-font-family: 'Poppins';
            --bf-dropdown-tile-item-text-typography-default-font-family: 'Poppins';
            --bf-dropdown-tile-item-text-typography-selected-font-family: 'Poppins';
            --bf-dropdown-tile-search-text-typography-font-family: 'Poppins';
            --bf-fileuploader-body-text-typography-font-family: 'Poppins';
            --bf-fileuploader-header-text-typography-font-family: 'Poppins';
            --bf-fileuploader-legal-text-typography-font-family: 'Poppins';
            --bf-header-text-typography-active-font-family: 'Poppins';
            --bf-header-text-typography-hover-font-family: 'Poppins';
            --bf-header-text-typography-inactive-font-family: 'Poppins';
            --bf-helptext-text-typography-font-family: 'Poppins';
            --bf-legalcheckbox-text-typography-font-family: 'Poppins';
            --bf-linkbutton-text-typography-font-family: 'Poppins';
            --bf-listingselector-description-typography-font-family: 'Poppins';
            --bf-listingselector-title-typography-font-family: 'Poppins';
            --bf-map-legend-label-text-typography-font-family: 'Poppins';
            --bf-map-legend-range-text-typography-font-family: 'Poppins';
            --bf-modal-confirmation-header-text-typography-font-family: 'Poppins';
            --bf-noticebar-description-text-typography-font-family: 'Poppins';
            --bf-noticebar-header-text-typography-font-family: 'Poppins';
            --bf-notification-badge-text-typography-normal-font-family: 'Poppins';
            --bf-notification-badge-text-typography-small-font-family: 'Poppins';
            --bf-numbercounter-text-typography-default-font-family: 'Poppins';
            --bf-numbercounter-text-typography-small-font-family: 'Poppins';
            --bf-pagination-text-typography-font-family: 'Poppins';
            --bf-popover-text-typography-font-family: 'Poppins';
            --bf-radio-description-typography-font-family: 'Poppins';
            --bf-radio-label-typography-normal-font-family: 'Poppins';
            --bf-selector-description-text-typography-default-font-family: 'Poppins';
            --bf-selector-description-text-typography-large-font-family: 'Poppins';
            --bf-selector-label-text-typography-default-font-family: 'Poppins';
            --bf-selector-label-text-typography-large-font-family: 'Poppins';
            --bf-selector-secondarylabel-text-typography-default-font-family: 'Poppins';
            --bf-selector-secondarylabel-text-typography-large-font-family: 'Poppins';
            --bf-selector-text-typography-default-font-family: 'Poppins';
            --bf-selector-text-typography-large-font-family: 'Poppins';
            --bf-tab-text-typography-inactive-font-family: 'Poppins';
            --bf-tab-text-typography-normal-font-family: 'Poppins';
            --bf-tag-text-amenities-typography-font-family: 'Poppins';
            --bf-tag-text-typography-font-family: 'Poppins';
            --bf-textfield-charactercount-text-typography-font-family: 'Poppins';
            --bf-textfield-text-typography-desktop-font-family: 'Poppins';
            --bf-textfield-text-typography-mobile-font-family: 'Poppins';
            --bf-textinput-input-text-typography-font-family: 'Poppins';
            --bf-textinput-textlabel-typography-default-font-family: 'Poppins';
            --bf-textinput-textlabel-typography-entered-font-family: 'Poppins';
            --bf-textinput-unitlabel-text-typography-font-family: 'Poppins';
            --bf-toast-description-text-typography-font-family: 'Poppins';
            --bf-toast-header-text-typography-font-family: 'Poppins';
            --bf-toggle-description-typography-font-family: 'Poppins';
            --bf-toggle-label-typography-normal-font-family: 'Poppins';
            --bf-tooltip-body-text-typography-font-family: 'Poppins';
            --bf-tooltip-header-text-typography-font-family: 'Poppins';
            --bf-tooltip-label-text-typography-font-family: 'Poppins';
            /* Bonfire alt font */
            --bf-desktop-body-large-alt-font-family: 'Poppins';
            --bf-desktop-body-medium-alt-font-family: 'Poppins';
            --bf-desktop-body-small-alt-font-family: 'Poppins';
            --bf-desktop-header-h1-alt-font-family: 'Poppins';
            --bf-desktop-header-h2-alt-font-family: 'Poppins';
            --bf-desktop-header-h3-alt-font-family: 'Poppins';
            --bf-desktop-header-h4-alt-font-family: 'Poppins';
            --bf-font-family-serif: 'Poppins';
            --bf-mobile-body-large-alt-font-family: 'Poppins';
            --bf-mobile-body-medium-alt-font-family: 'Poppins';
            --bf-mobile-body-small-alt-font-family: 'Poppins';
            --bf-mobile-header-h1-alt-font-family: 'Poppins';
            --bf-mobile-header-h2-alt-font-family: 'Poppins';
            --bf-mobile-header-h3-alt-font-family: 'Poppins';
            --bf-mobile-header-h4-alt-font-family: 'Poppins';
            /* Renter */
            --renter-primary-font-family: 'Poppins';

            /* Bonfire buttons */
            --bf-button-background-color-primary-active: #373e46;
            --bf-button-background-color-primary-active: #373e46;
            --bf-button-text-color-primary-active: #fff;
            --bf-button-background-color-primary-inactive: #e2e6ed;
            --bf-button-background-color-primary-inactive: #e2e6ed;
            --bf-button-text-color-primary-inactive: #4f5b69;
            --bf-button-background-color-primary-hover: #212831;
            --bf-button-background-color-primary-hover: #212831;
          }
        `}</style>
      </Head>
    </>
  );
};
